<template>
	<div>
		<GalleryType :items="content.gallery" :type="content.galleryType" />
	</div>
</template>

<script>
import GalleryType from '@/components/Gallery/Component'
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {
		GalleryType,
	},
}
</script>

<style lang="scss" scoped></style>
